// Imports
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from '@tippyjs/react';
import { DateTime } from 'luxon';
import styled from 'styled-components/macro';
import tippyProps from '../../../../../../shareables/foundation/front-end/utils/tippy-props';
import supportedFileTypes from '../../../../../../shareables/front-end/supported-file-types';
import { GetDocumentsResponse } from '../../../../../../shareables/types/api/main/website/page/type/201/documents/get';


// Styled components
const TableRow = styled.tr`
	a > svg {
		color: initial;
	}
	
	td:not(:last-child) {
		padding-top: 0.375rem !important;
	}
`;

const FileIconCell = styled.td`
	width: 3.125rem;
	font-size: 1.6875rem;
	line-height: 1;
`;

const SubText = styled.p`
	font-size: 75%;
	font-style: italic;
	padding-bottom: 0.0625rem;
`;


// Define the accepted props
interface Props {
	document: GetDocumentsResponse[0];
	pageID: number;
}


// Function component
const DocumentsRow: React.FC<Props> = ({ document, pageID }) => {
	/* Determines if file type is supported */
	const isSupportedFileType = (fileType: string): fileType is keyof typeof supportedFileTypes =>
		Object.prototype.hasOwnProperty.call(supportedFileTypes, fileType);
	
	
	// Get file type/extension
	const fileType = document.friendlyFilename.slice(document.friendlyFilename.lastIndexOf('.') + 1).toLowerCase();
	
	
	// Initialize
	let fileTypeIcon: React.ReactNode = null;
	
	let fileTypeText: React.ReactNode = null;
	
	const fileLink = `https://${window.location.hostname}/private-files/document/${pageID}/${window.encodeURIComponent(document.filename)}/${window.encodeURIComponent(
		document.friendlyFilename
	)}`;
	
	
	// Build file type JSX
	if (isSupportedFileType(fileType)) {
		fileTypeIcon = <FontAwesomeIcon icon={supportedFileTypes[fileType].icon} />;
		
		fileTypeText = <span>[{supportedFileTypes[fileType].label}]</span>;
	} else {
		fileTypeIcon = <FontAwesomeIcon icon={faFile} />;
		
		fileTypeText = <span>[{fileType.toUpperCase()} File]</span>;
	}
	
	
	// Initialize
	return (
		<TableRow>
			<FileIconCell>
				<a href={fileLink} aria-label={document.title}>
					{fileTypeIcon}
				</a>
			</FileIconCell>
			
			<td className='allow-wrapping'>
				<a href={fileLink}>{document.title}</a>
				<br />
				<SubText>{fileTypeText}</SubText>
			</td>
			
			<td>
				<Tippy
					{...tippyProps}
					content={new Date(document.uploaded).toLocaleDateString(undefined, {
						month: 'long',
						day: 'numeric',
						year: 'numeric',
					})}
				>
					<span>{DateTime.fromISO(document.uploaded).toRelative()}</span>
				</Tippy>
			</td>
		</TableRow>
	);
};

export default DocumentsRow;
